<template>
    <main class="flex-1 max-md:pb-24">
        <section
            class="z-[1] bg-white lg:sticky lg:top-[72px] lg:border-b lg:pb-7 lg:pt-8"
        >
            <figure class="container mx-auto w-full px-6 md:px-12">
                <figure class="w-full items-center justify-between lg:flex">
                    <div
                        class="mb-5 text-heading-2-mobile text-black-78 md:mb-0 lg:text-heading-2-desktop"
                    >
                        Vaši oglasi
                    </div>
                    <div
                        class="fixed left-0 right-0 top-0 z-30 flex flex-row flex-wrap items-center justify-between gap-[10px] bg-white px-4 max-md:h-[72px] max-md:border-b md:relative"
                    >
                        <a
                            href="javascript:history.back();"
                            class="button button--navbar button--white md:hidden"
                        >
                            <v-icon icon="back"></v-icon>
                            <label>Nazaj</label>
                        </a>
                        <!-- <v-search-sort></v-search-sort> -->
                    </div>
                    <div
                        class="flex flex-row flex-wrap items-center gap-[10px]"
                    >
                        <div class="hidden items-center gap-2 md:flex">
                            <v-icon icon="filter"></v-icon>
                            <label class="text-small-text-medium text-black-78"
                                >Filtriraj</label
                            >
                        </div>
                        <hr
                            class="mx-2 hidden h-[38px] w-[1px] bg-gray-border md:flex"
                        />
                        <a
                            class="flex min-h-[38px] items-center justify-center rounded-3xl px-6 py-3 text-small-text-medium text-black-78 shadow"
                            :class="[
                                showAll
                                    ? 'bg-green-25 text-green shadow-inner'
                                    : 'cursor-pointer bg-white',
                            ]"
                            @click="showContent('showAll')"
                        >
                            <label class="pointer-events-none">Vse</label>
                        </a>
                        <a
                            class="flex min-h-[38px] items-center justify-center rounded-3xl px-6 py-3 text-small-text-medium text-black-78 shadow"
                            :class="[
                                showListed
                                    ? 'bg-green-25 text-green shadow-inner'
                                    : 'cursor-pointer bg-white',
                            ]"
                            @click="showContent('showListed')"
                        >
                            <label class="pointer-events-none"
                                >Objavljeno</label
                            >
                        </a>
                        <a
                            class="flex min-h-[38px] items-center justify-center rounded-3xl px-6 py-3 text-small-text-medium text-black-78 shadow"
                            :class="[
                                showDeactivated
                                    ? 'bg-green-25 text-green shadow-inner'
                                    : 'cursor-pointer bg-white',
                            ]"
                            @click="showContent('showDeactivated')"
                        >
                            <label class="pointer-events-none"
                                >Deaktivirano</label
                            >
                        </a>
                        <a
                            class="flex min-h-[38px] items-center justify-center rounded-3xl px-6 py-3 text-small-text-medium text-black-78 shadow"
                            :class="[
                                showDrafts
                                    ? 'bg-green-25 text-green shadow-inner'
                                    : 'cursor-pointer bg-white',
                            ]"
                            @click="showContent('showDrafts')"
                        >
                            <label class="pointer-events-none">Osnutek</label>
                        </a>
                        <a
                            class="flex min-h-[38px] items-center justify-center rounded-3xl px-6 py-3 text-small-text-medium text-black-78 shadow"
                            :class="[
                                showRejected
                                    ? 'bg-green-25 text-green shadow-inner'
                                    : 'cursor-pointer bg-white',
                            ]"
                            @click="showContent('showRejected')"
                        >
                            <label class="pointer-events-none">Odloženo</label>
                        </a>
                    </div>
                </figure>
            </figure>
        </section>
        <section class="container mx-auto px-6 pb-12 md:px-12">
            <figure
                class="mx-auto mt-10 flex w-full flex-col gap-8 lg:mt-11 lg:flex-row"
            >
                <figure class="flex flex-1 flex-wrap gap-8 px-2 md:px-0">
                    <template v-if="showAll">
                        <v-listings-list
                            :listings="allListings"
                            :locations="locations"
                            :header-setup-data="headerSetupData"
                            :hide-empty-state="unfinishedListings.length > 0 || (unfinishedListings.length == 0 && allListings.length == 0)"
                        ></v-listings-list>
                        <v-drafts-list
                            :listings="unfinishedListings"
                            :locations="locations"
                            :header-setup-data="headerSetupData"
                            :hide-empty-state="allListings.length > 0"
                        ></v-drafts-list>
                    </template>
                    <template v-else-if="showListed">
                        <v-listings-list
                            :listings="publishedListings"
                            :locations="locations"
                            :header-setup-data="headerSetupData"
                        ></v-listings-list>
                    </template>
                    <template v-else-if="showDeactivated">
                        <v-listings-list
                            :listings="deactivatedListings"
                            :locations="locations"
                            :header-setup-data="headerSetupData"
                        ></v-listings-list>
                    </template>
                    <template v-else-if="showDrafts">
                        <v-drafts-list
                            :listings="unfinishedListings"
                            :locations="locations"
                            :header-setup-data="headerSetupData"
                        ></v-drafts-list>
                    </template>
                    <template v-else-if="showRejected">
                        <v-listings-list
                            :listings="rejectedListings"
                            :locations="locations"
                            :header-setup-data="headerSetupData"
                        ></v-listings-list>
                    </template>
                </figure>
                <hr class="md:hidden" />
                <figure class="w-full max-w-[624px]">
                    <figure class="lg:sticky lg:top-[228px]">
                        <div class="text-heading-3-desktop text-black-78">
                            Statusi oglasa
                        </div>
                        <div class="mt-4 rounded-3xl p-8 shadow lg:p-11">
                            <section>
                                <div
                                    class="mb-2 flex items-center gap-2 text-icon-text-medium text-green"
                                >
                                    <v-icon icon="circle-check"></v-icon>
                                    <label class="">Objavljeno</label>
                                </div>
                                <p class="text-body-regular text-black-40">
                                    Za objavo oglasa ste plačali in je javno
                                    objavljen na portalu N24 ter trenutno viden
                                    vsem iskalcem portala.
                                </p>
                            </section>
                            <hr class="my-6" />
                            <section>
                                <div
                                    class="mb-2 flex items-center gap-2 text-icon-text-medium text-black-78"
                                >
                                    <v-icon icon="pause"></v-icon>
                                    <label class="">Deaktivirano</label>
                                </div>
                                <p class="text-body-regular text-black-40">
                                    Oglas trenutno ni viden iskalcem portala,
                                    vendar je shranjen v naši bazi. Za javno
                                    objavo na portalu N24 je potrebno zakupiti
                                    trajanje oglasa.
                                </p>
                            </section>
                            <hr class="my-6" />
                            <section>
                                <div
                                    class="mb-2 flex items-center gap-2 text-icon-text-medium text-black-78"
                                >
                                    <v-icon icon="draft"></v-icon>
                                    <label class="">Osnutek</label>
                                </div>
                                <p class="text-body-regular text-black-40">
                                    Vnosa oglasa niste dokončali. Nadaljujete
                                    lahko s klikom na gumb “nadaljujte z objavo”
                                    in po končanem vnosu zakupite trajanje
                                    oglasa.
                                </p>
                            </section>
                            <hr class="my-6" />
                            <section>
                                <div
                                    class="mb-2 flex items-center gap-2 text-icon-text-medium text-salmon"
                                >
                                    <v-icon icon="cancel"></v-icon>
                                    <label class="">Odloženo</label>
                                </div>
                                <p class="text-body-regular text-black-40">
                                    Oglas ni bil pravilno izpolnjen ali ni bil v
                                    skladu z našimi smernicami. Oglas lahko
                                    popravite in ga po končanih popravkih
                                    aktivirate.
                                </p>
                            </section>
                        </div>
                    </figure>
                </figure>
            </figure>
        </section>
    </main>
</template>

<script>
import Glide from "@glidejs/glide";
import ListingsList from "./ListingsList.vue";
import DraftsList from "./DraftsList.vue";

export default {
    components: {
        "v-listings-list": ListingsList,
        "v-drafts-list": DraftsList,
    },
    props: {
        allListings: {
            type: Object,
            required: true,
        },
        unfinishedListings: {
            type: Object,
            required: true,
        },
        deactivatedListings: {
            type: Object,
            required: true,
        },
        publishedListings: {
            type: Object,
            required: true,
        },
        rejectedListings: {
            type: Object,
            required: true,
        },
        locations: {
            type: Object,
            required: true,
        },
        headerSetupData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showAll: true,
            showListed: false,
            showDeactivated: false,
            showDrafts: false,
            showRejected: false,
        };
    },
    methods: {
        showContent(content) {
            this.showAll = false;
            this.showListed = false;
            this.showDeactivated = false;
            this.showDrafts = false;
            this.showRejected = false;
            this[content] = true;
        },
    },
};
</script>
